import { Directive, inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { InputErrorMatcher } from '@qaroni-core/utils/validations/input-error-matcher';
import { InputValidation } from '@qaroni-core/utils/validations/input-validation';

@Directive()
export class QaroniBaseFormsDirective extends QarepaBaseSubsDirective {
  protected fb = inject(UntypedFormBuilder);

  protected InputValidation = InputValidation;
  protected InputErrorMatcher = new InputErrorMatcher();

  protected submitting = false;

  protected enableLoading(): void {
    this.submitting = true;
  }

  protected disableLoading(): void {
    this.submitting = false;
  }
}
